export interface SearchBorrowHistoriesRequest {
  searchFlag: BorrowHistorySearchFlag
  borrowingDate: string
  borrowingDateFrom: string
  borrowingDateTo: string
  interlibraryLoanCode: string
  requestBranchCode: string
}

export const BorrowHistorySearchFlag = {
  PrefixMatch: '1',
  RangeSpecification: '2'
} as const
export type BorrowHistorySearchFlag = typeof BorrowHistorySearchFlag[keyof typeof BorrowHistorySearchFlag]

export const defaultSearchBorrowHistoriesRequest = (): SearchBorrowHistoriesRequest => ({
  searchFlag: BorrowHistorySearchFlag.PrefixMatch,
  borrowingDate: '',
  borrowingDateFrom: '',
  borrowingDateTo: '',
  interlibraryLoanCode: '',
  requestBranchCode: ''
})

export function SearchBorrowHistoriesRequestToJSON(
  value: SearchBorrowHistoriesRequest
): any {
  return {
    search_flag: value.searchFlag ? value.searchFlag : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_date_from:
      value.borrowingDateFrom !== '' ? value.borrowingDateFrom : undefined,
    borrowing_date_to:
      value.borrowingDateTo !== '' ? value.borrowingDateTo : undefined,
    interlibrary_loan_code:
      value.interlibraryLoanCode !== ''
        ? value.interlibraryLoanCode
        : undefined,
    request_branch_code:
      value.requestBranchCode !== '' ? value.requestBranchCode : undefined
  }
}
